/**
 * QA-514 역할별 접근 메뉴 — 최고관리자가 [역할 권한 관리]에서 역할마다 보여 줄 BO 메뉴를 고른다. 로그인한 관리자의 허용 메뉴는
 * `GET /admin/v1/me` 의 `menus`(가진 역할들의 합집합, null = 제한 없음)로 온다. BE 반영 전 응답엔 필드가 없어 제한 없음과 같다.
 *
 * 메뉴 노출만 거른다(사이드바·즐겨찾는 메뉴·명령 팔레트). API 권한은 BE 가 역할로 따로 막는다.
 */
export const menusOf = (admin: unknown): ReadonlyArray<string> | null => {
  const menus = (admin as { menus?: unknown } | null | undefined)?.menus;
  return Array.isArray(menus) ? menus.filter((m): m is string => typeof m === 'string') : null;
};

/** 경로가 허용 메뉴 안인지 — 메뉴 그 자체이거나 그 아래 화면(/products → /products/new). 쿼리는 뺀다. */
export const isPathAllowedByMenus = (menus: ReadonlyArray<string> | null, to: string): boolean => {
  if (menus === null) return true;
  const path = to.split('?')[0] ?? to;
  return menus.some((m) => {
    const menu = m.split('?')[0] ?? m;
    return path === menu || path.startsWith(`${menu}/`);
  });
};

/** 사이드바 메뉴 하나가 허용인지 — 메뉴는 정확히 같은 주소로 고른다(/orders 를 골라도 /orders/exports 메뉴는 따로). */
export const isMenuAllowed = (menus: ReadonlyArray<string> | null, to: string): boolean =>
  menus === null || menus.includes(to);
